<div [formGroup]="cofinsForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="COFINS"
        descricaoAtivo="COFINS ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="COFINS inativo. Nenhum valor de COFINS será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o COFINS acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-cofins-tributo-regra-section
        [form]="cofinsForm"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCodigoTributo.length === 0"
        [tipoOperacao]="tipoOperacaoValue"
        (personalizar)="abrirEditorFormulas()">
    </app-cofins-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-cofins-tributo-observacoes-section
        [control]="$any(cofinsForm.get('observacao'))"
        [variaveis]="cofinsForm.get('cstCofins')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-cofins-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-cofins-tributo-observacoes-fisco-section
        [control]="$any(cofinsForm.get('observacaoFisco'))"
        [variaveis]="cofinsForm.get('cstCofins')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-cofins-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-cofins-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [variaveis]="variaveisUnicas"
        [formulasCofins]="formulasCofins"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-cofins-tributo-excecoes-section>

    }

</div>
